import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import React, { useEffect, useRef, useState } from 'react';
import useStorage from '@/utils/useStorage';
import locale from './locale';
import styles from './style/index.module.less';
import api from '@/api';
import { secret } from '@/api/encrypt';
import useTranslation from '@/utils/useTranslation';
export default function LoginForm() {
  const t = useTranslation(locale);
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false); // 多租户选择
  const [form, setForm] = useState({}); //
  const [tenants, setTenants] = useState([]); //
  const [loginParams, setLoginParams, removeLoginParams] = useStorage('loginParams');
  const [rememberPassword, setRememberPassword] = useState(!!loginParams);
  function afterLoginSuccess(params, data) {
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    }
    // 记录登录状态
    localStorage.setItem('userStatus', 'login');

    // 跳转首页
    if (data.tenant_dashboard) {
      let dashboardUrl = data.tenant_dashboard;
      if (!dashboardUrl.startsWith('/')) {
        dashboardUrl = '/' + dashboardUrl;
      }
      window.location.href = dashboardUrl;
    } else {
      window.location.href = '/admin/dashboard/workplace';
    }
  }
  function login(params) {
    setErrorMessage('');
    params.username = secret(params.username);
    params.pwd = secret(params.pwd);
    api.post('/api/user/login', params, {}, setLoading).then(res => {
      const ret = res.data;
      if (ret.code === 0) {
        if (ret.data.tenant_id == 0) {
          // Message.error('缺少租户信息');
          setTenants(ret.data['tenants']);
          setVisible(true);
          return;
        } else {
          _Message.success('登录成功');
          afterLoginSuccess(params, ret.data);
        }
      } else {
        setErrorMessage(ret.msg || t('login.form.login.errMsg'));
      }
    });
  }
  function onSubmitClick() {
    formRef.current.validate().then(values => {
      console.log(values);
      setForm({
        username: values.username,
        pwd: values.pwd
      });
      login(values);
    });
  }

  // 读取 localStorage，设置初始值
  useEffect(() => {
    const rememberPassword = !!loginParams;
    setRememberPassword(rememberPassword);
    if (formRef.current && rememberPassword) {
      const parseParams = JSON.parse(loginParams);
      formRef.current.setFieldsValue(parseParams);
    }
  }, [loginParams]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-title']
  }, t('黄山圣天地养老系统')), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-sub-title']
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-error-msg']
  }, errorMessage), /*#__PURE__*/React.createElement(_Form, {
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef,
    initialValues: {
      username: 'admin',
      pwd: '123456'
    }
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "username",
    rules: [{
      required: true,
      message: t('login.form.userName.errMsg')
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconUser, null),
    placeholder: t('login.form.userName.placeholder'),
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "pwd",
    rules: [{
      required: true,
      message: t('login.form.password.errMsg')
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t('login.form.password.placeholder'),
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t('login.form.login')))), /*#__PURE__*/React.createElement(_Modal, {
    title: "\u9009\u62E9\u60A8\u7684\u89D2\u8272",
    visible: visible,
    onOk: () => setVisible(false),
    onCancel: () => setVisible(false),
    autoFocus: false,
    focusLock: true,
    footer: null
  }, /*#__PURE__*/React.createElement(_Space, {
    style: {
      width: '100%',
      border: '0px solid var(--color-border)',
      borderRadius: 4,
      padding: 0
    },
    direction: "vertical",
    size: "large"
  }, tenants.map(item => {
    return /*#__PURE__*/React.createElement(_Button, {
      key: item.tenant_id,
      type: "secondary",
      long: true,
      onClick: () => {
        setVisible(false);
        const params = {
          ...form,
          tenant_id: item.tenant_id
        };
        login(params);
      }
    }, item.tenant_name);
  }))));
}